module.exports = __webpack_public_path__ + "static/media/tutorial-6.cf230d28.jpg";